module.exports = __webpack_public_path__ + "img/company.9ac3fa6a.svg";